import { UrlObject } from 'url';

export const routePath = {
  adminEvents: '/admin/events',
  adminInventoryHealth: '/admin/inventory-health',
  contact: '/directory/point-of-contact/[id]',
  dedicatedForumCreate: '/dedicated-forum/create',
  dedicatedForumDetail: '/dedicated-forum/[id]',
  directory: '/directory',
  directoryContacts: '/directory/contacts/',
  directoryMembers: '/directory/members/',
  error: '/error',
  glossary: '/glossary',
  help: '/help',
  home: '/',
  login: '/login',
  inventory: '/inventory',
  inventoryAllObjects: '/inventory/all-space-objects',
  inventoryMyFleet: '/inventory/my-fleet',
  member: '/directory/member/[id]',
  memberCreate: '/directory/add-member',
  memberEdit: '/directory/member/[id]/edit',
  messages: '/messages',
  notFound: '/404',
  profile: '/profile',
  profileSpaceObjectTab: '/profile/space-objects',
  spaceObject: '/inventory/object/[id]',
  spaceObjectCreate: '/inventory/add-space-object',
  spaceObjectEdit: '/inventory/object/[id]/edit',
  sstForum: '/sst-forum',
  sst: '/sst/[id]',
  sstCreate: '/sst-forum/publish/[id]',
  sstCreateForUnknownSpaceObject: '/sst-forum/publish/unknown-space-object',
  sstPublish: '/sst-forum/publish',
  pdfViewer: '/pdf-viewer',
};

const getRoute = {
  adminEvents: (): UrlObject => ({ pathname: routePath.adminEvents }),
  adminInventoryHealth: (): UrlObject => ({ pathname: routePath.adminInventoryHealth }),
  contact: (id: string): UrlObject => ({
    pathname: routePath.contact,
    query: { id },
  }),
  dedicatedForum: (): UrlObject => ({ pathname: '/dedicated-forum' }),
  dedicatedForumCreate: (): UrlObject => ({ pathname: routePath.dedicatedForumCreate }),
  dedicatedForumDetail: (id: string): UrlObject => ({
    pathname: routePath.dedicatedForumDetail,
    query: { id },
  }),
  directory: (): UrlObject => ({ pathname: routePath.directory }),
  directoryContacts: (): UrlObject => ({ pathname: routePath.directoryContacts }),
  directoryMembers: (): UrlObject => ({ pathname: routePath.directoryMembers }),
  home: (): UrlObject => ({
    pathname: '/',
  }),
  inventory: (): UrlObject => ({
    pathname: routePath.inventory,
  }),
  inventoryAllObjects: (): UrlObject => ({ pathname: routePath.inventoryAllObjects }),
  inventoryMyFleet: (): UrlObject => ({ pathname: routePath.inventoryMyFleet }),
  glossary: (): UrlObject => ({
    pathname: routePath.glossary,
  }),
  help: (): UrlObject => ({
    pathname: routePath.help,
  }),
  login: (): UrlObject => ({
    pathname: routePath.login,
  }),
  profile: (): UrlObject => ({
    pathname: routePath.profile,
  }),
  profileSpaceObjects: (): UrlObject => ({
    pathname: routePath.profileSpaceObjectTab,
  }),
  spaceObjectEdit: (id: string): UrlObject => ({
    pathname: routePath.spaceObjectEdit,
    query: { id },
  }),
  editMember: (id: string): UrlObject => ({
    pathname: routePath.memberEdit,
    query: { id },
  }),
  member: (id: string): UrlObject => ({
    pathname: routePath.member,
    query: { id },
  }),
  error: (): UrlObject => ({
    pathname: routePath.error,
  }),
  notFound: (): UrlObject => ({
    pathname: routePath.notFound,
  }),
  sstForum: (): UrlObject => ({
    pathname: routePath.sstForum,
  }),
  sst: (id: string): UrlObject => ({
    pathname: routePath.sst,
    query: { id },
  }),
  sstCreate: (id: string): UrlObject => ({
    pathname: routePath.sstCreate,
    query: { id },
  }),
  sstCreateForUnknownSpaceObject: (): UrlObject => ({
    pathname: routePath.sstCreateForUnknownSpaceObject,
  }),
  sstForumPublish: (): UrlObject => ({
    pathname: routePath.sstPublish,
  }),
  messages: (conversationId?: string): UrlObject => ({
    pathname: routePath.messages,
    ...(conversationId ? { query: { conversationId } } : {}),
  }),
  messageContact: (id: string): UrlObject => ({
    pathname: routePath.messages,
    query: { newChatWith: id },
  }),
  spaceObject: (id: string): UrlObject => ({
    pathname: routePath.spaceObject,
    query: { id },
  }),
  memberCreate: (): UrlObject => ({ pathname: routePath.memberCreate }),
  pdfViewer: (url: string): UrlObject => ({
    pathname: routePath.pdfViewer,
    query: { url },
  }),
};

export default getRoute;

export const isRouteActive = (
  currentPath: string,
  routePathname: string | null | undefined,
  itemId: string,
): boolean => {
  if (!routePathname) {
    return false;
  }
  if (currentPath === routePathname) {
    return true;
  }

  const activePaths: Record<string, string | null | undefined> = {
    'admin-events': getRoute.adminEvents().pathname,
    'admin-inventory-health': getRoute.adminInventoryHealth().pathname,
    members: getRoute.directory().pathname,
    inventory: getRoute.inventory().pathname,
    'sst-forum': getRoute.sstForum().pathname,
  };

  return activePaths[itemId] ? currentPath.startsWith(activePaths[itemId]) : false;
};
